import { render } from "./AppConfirmDeleteDialog.vue?vue&type=template&id=5155342b&ts=true"
import script from "./AppConfirmDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./AppConfirmDeleteDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__